import { UserRegion } from "./enums/UserRegionEnum.js";

export const redirectToAppropriateHost = (region, Hosts) => {
  let redirectHost = Hosts.BRASIL;

  if (region && Object.values(UserRegion).includes(region)) {
    redirectHost = Hosts[region];
  } else {
    const { href } = window.location;
    
    if (href.includes(UserRegion.CONOSUR.toLowerCase())) {
      redirectHost = Hosts.CONOSUR;
    } else if (href.includes(UserRegion.PACA.toLowerCase())) {
      redirectHost = Hosts.PACA;
    } else if (href.includes(UserRegion.MEXICO.toLowerCase())) {
      redirectHost = Hosts.MEXICO;
    }
  }

  window.location.replace(redirectHost);
};

export default redirectToAppropriateHost;



// WEBPACK FOOTER //
// ./src/helpers/redirectToAppropriateHost.js